import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;

  @media (width < 1024px) {
    padding: 40px 32px;
  }

  @media (width >= 1024px) {
    align-items: center;
    padding: 88px 0;
  }
`;

export const Title = styled.div`
  font-size: 40px;
  font-weight: 700;
  line-height: 42px;
  text-transform: uppercase;

  @media (width >= 1024px) {
    text-align: center;
  }
`;

export const Container = styled.div`
  width: 100%;

  @media (width >= 1024px) {
    max-width: 640px;
  }

  @media (width >= 1440px) {
    max-width: 1368px;
  }
`;

export const Grid = styled.div`
  width: 100%;

  @media (width < 1440px) {
    display: flex;
    flex-direction: column;
    gap: 48px;
    padding: 32px 0;
  }

  @media (width >= 1440px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 81px 112px;
    padding: 80px 0;
  }
`;

export const Item = styled.div`
  display: flex;
  column-gap: 31px;
`;

export const ItemImage = styled.img`
  @media (width < 1024px) {
    display: none;
  }

  @media (width >= 1024px) {
    flex-shrink: 0;
    width: 211px;
    height: 211px;
    border-radius: 50%;
    overflow: hidden;
    object-fit: cover;
  }
`;

export const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Name = styled.div`
  font-size: 20px;
  font-weight: 700;
  line-height: 25px;
`;

export const CompanyName = styled.div`
  color: #9a98a0;
  font-size: 17px;
  line-height: 32px;
  letter-spacing: 0.17px;
`;

export const Review = styled.p`
  margin-top: 16px;
  padding-top: 23px;
  font-size: 17px;
  line-height: 25px;
  letter-spacing: 0.17px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='19px' height='14px' viewBox='0 0 19 14'%3E%3Cpath fill='%23E74391' d='M0 13.721V8.57C0 6.128.578 4.2 1.733 2.784 2.905 1.368 4.606.44 6.836 0v2.539c-1.66.521-2.775 1.416-3.345 2.686A4.35 4.35 0 0 0 3.125 7.3h3.833v6.421H0ZM18.408 2.539c-1.644.505-2.751 1.416-3.32 2.735-.326.7-.456 1.375-.391 2.026h3.833v6.421h-6.958V8.57c0-2.474.594-4.411 1.782-5.811C14.559 1.359 16.243.44 18.408 0v2.539Z' /%3E%3C/svg%3E");
  background-repeat: no-repeat;
`;
